export default {
  upload: {
    dropFiles: 'Dateien hier ablegen, um sie hochzuladen',
    delete: 'Löschen',
    deleteAllConfirm: 'Möchten Sie wirklich alle Dateien löschen?',
    deleteConfirm: 'Möchten Sie {filename} wirklich löschen?',
    deleteAllSuccess: 'Alle Dateien erfolgreich gelöscht!',
    deleteSuccess: '{filename} erfolgreich gelöscht!',
    deleteCancelled: 'Löschung abgebrochen',
    warning: 'Warnung',
    cancel: 'Abbrechen',
    fileSize: 'Größe: {size} KB'
  },
  test: {
    title: 'i18n-Testansicht',
    description: 'Dies ist eine Testansicht, um die i18n-Funktionen zu demonstrieren.',
    item1: 'Erstes Element',
    item2: 'Zweites Element',
    item3: 'Drittes Element'
  },
  footer: {
    copyright: '© {year} Varena Agropecuaria Ltda. Alle Rechte vorbehalten.'
  },
  table: {
    mdthisIsASwalAlert: 'Dies ist eine Swal-Warnung. Modus: {mode} - URL: {url}'
  },
  appleFarm: {
    title: 'Willkommen bei Varena Agropecuaria',
    about: 'Varena Agropecuria ist seit der Gründung vor über 30 Jahren ein familiengeführter Betrieb mit Sitz in Monte Alegre dos Campos, Rio Grande do Sul, Brasilien. Unser Engagement gilt der Produktion von Äpfeln höchster Qualität und den besten landwirtschaftlichen Praktiken.',
    apples: 'Bei Varena bauen wir verschiedene Apfelsorten für jeden Geschmack an. Wir haben unterschiedliche Apfelsorten wie Gala und Fuji.',
  },
  fujiApples: {
    title: 'Alles über Fuji-Äpfel',
    intro: 'Hier ist alles, was Sie über süße Fuji-Äpfel wissen müssen.',
    tips: {
      tip1: 'Fuji-Äpfel sind eine relativ neue Sorte. Sie wurden in den späten 1930er Jahren erstmals in Japan gezüchtet, kamen aber erst 1962 auf den Weltmarkt.',
      tip2: 'Sie sind das Ergebnis einer erfolgreichen Kreuzung zwischen zwei amerikanischen Sorten, Red Delicious und Virginia Ralls Janet.',
      tip3: 'Bekannt für ihre Süße, haben Fuji-Äpfel einen der höchsten Zuckergehalte unter den Äpfeln auf dem Markt mit etwa 14g Zucker pro 100g.',
      tip4: 'Machen Sie süße Fuji-Äpfel noch süßer, indem Sie sie in Gelees und Tee verwenden.',
      tip5: 'Sie halten sich drei Monate im Kühlschrank. Trennen Sie beschädigte Äpfel, um die anderen länger frisch zu halten.',
      tip6: 'Apfelschale ist eine gute Quelle für Pektin, eine Form von löslichen Ballaststoffen. Pektin kann helfen, Cholesterin- und Blutzuckerspiegel zu senken.',
      tip7: 'Lust auf einen Snack spät in der Nacht? Ein Apfel ist eine gute Wahl, da er einen niedrigen glykämischen Index hat und reich an Ballaststoffen ist.',
      tip8: 'Um zu verhindern, dass geschnittene Äpfel braun werden, legen Sie sie in eine Mischung aus 1 EL Zitronensaft und 1 Tasse Wasser.',
      tip9: 'Knackig frische Fuji-Äpfel sind zwischen April und Oktober auf ihrem süßen, saftigen Höhepunkt.',
      tip10: 'Fügen Sie fein geschnittene Fuji-Äpfel zu Salaten, Müsli und Krautsalat für Frische und Knusprigkeit hinzu.'
    },
    funFacts: {
      title: 'Interessante Fakten',
      fact1: 'Viele denken, Fuji-Äpfel seien nach dem Berg Fuji benannt, aber der Name kommt tatsächlich von Fujisaki, der japanischen Stadt, in der sie entwickelt wurden.',
      fact2: 'Ein großer Fuji kann Ihnen 15 Prozent Ihres täglichen Vitamin-C-Bedarfs liefern.',
      fact3: 'Fujis sind einer der besten Äpfel zum Einfrieren.',
      fact4: 'Fujis eignen sich hervorragend zum Füllen und Rösten, da sie ihre Form beim Kochen behalten.'
    },
    reference: 'Quelle: taste.com.au'
  },
  galaApples: {
    title: 'Alles über Gala-Äpfel',
    intro: 'Hier sind 7 Fakten, die Sie wahrscheinlich noch nicht über Gala-Äpfel wussten.',
    facts: {
      fact1: {
        title: 'Ursprung',
        content: 'Der Gala-Apfel ist eine alte Sorte aus Greytown, Neuseeland, und eine Selektion von JH Kidd aus der Kreuzung zwischen "Kidss Orange" und "Golden Delicious". Es ist die Sorte mit der höchsten Produktion im Bundesstaat Washington.'
      },
      fact2: {
        title: 'Hauptverwendung',
        content: 'Im Vergleich zu anderen Sorten verstärkt sich die Süße des Gala-Apfels beim Kochen. Daher wird empfohlen, ihn roh zu essen oder süße Desserts wie einen gebackenen Kuchen zuzubereiten.'
      },
      fact3: {
        title: 'Weltweite Nachfrage',
        content: 'Es ist eine der weltweit am häufigsten angebauten Sorten, dank ihres Geschmacks, des saftigen und knackigen Fruchtfleisches und der guten Balance zwischen Zucker und Säure.'
      },
      fact4: {
        title: 'Süße und Geschmack',
        content: 'Er hat eine ausgewogene Süße mit einem leichten Säuretouch und Noten von Limette, weißem Tee und Johannisbeeren. Es ist ein fleischiger Apfel.'
      },
      fact5: {
        title: 'Einfacher Verzehr',
        content: 'Sie färben nicht ab und zerfallen nicht, sie sind der ideale Snack für überall, ob nach den Mahlzeiten oder wenn Sie Ihre Zahnbürste vergessen haben.'
      },
      fact6: {
        title: 'Hydratation',
        content: 'Sie sind sehr erfrischend und hydratisieren uns fast unmerklich, sie sind perfekt, um uns auf allen Ebenen frisch zu halten, körperlich und geistig.'
      },
      fact7: {
        title: 'Energiebeitrag',
        content: 'Der Gala-Apfel hat einen hohen Gehalt an Vitaminen und Mineralstoffen sowie Kohlenhydraten (besonders in Form von Fruktose), die vom Körper leichter aufgenommen werden können.'
      }
    },
    reference: 'Quelle: manzanaswashington.com'
  }, excel: {
    edit: {
      title: 'Eintrag bearbeiten'
    },
    actions: {
      edit: 'Bearbeiten',
      viewHistory: 'Verlauf anzeigen'
    },
    fields: {
      id: 'ID',
      date: 'Datum',
      value: 'Wert',
      description: 'Beschreibung',
      lastModified: 'Zuletzt bearbeitet',
      newDescription: 'Neue Beschreibung',
      existingDescription: 'Vorhandene Beschreibung',
      selectDescription: 'Beschreibung auswählen'
    }, 
    history: {
      title: 'Verlauf - {descricao}',
      chartTitle: 'Verlauf - {timeGrouping}',
      detailed: 'Detailliert',
      monthly: 'Monatlich',
      yearly: 'Jährlich'
    },
    browser: {
      title: "Beschreibungsverlauf",
      selectTitle: "Beschreibung auswählen",
      selectMode: "Auswahlmodus",
      viewHistory: "Verlauf anzeigen"
    }
  },
  common: {
    save: 'Änderungen speichern',
    cancel: 'Abbrechen',
    backToList: 'Zurück zur Liste',
    delete: 'Löschen'
  },
  valve: {
    stopped: 'Geschlossen',
    running: 'Offen',
    start: 'Starten',
    stop: 'Stoppen',
    title: 'Magnetventile',
    name: 'Ventil',
    title_valves: 'Magnetventile'

  }, colheita: {
    title: 'Eingabe der Bins-Menge',
    select_date: 'Datum auswählen',
    select_setor: 'Setor auswählen',
    select_type: 'Typ auswählen',
    setor: 'Setor',
    gala: 'Gala',
    fuji: 'Fuji',
    quantity: 'Menge',
    add_entry: 'Eintrag hinzufügen',
    review_submit: 'Überprüfen und senden',
    entry: 'Eintrag',
    date: 'Datum',
    type: 'Typ',
    review_title: 'Einträge überprüfen',
    submit: 'Senden',
    cancel: 'Abbrechen',
    success: 'Erfolg',
    error: 'Fehler',
    submit_success: 'Einträge erfolgreich gesendet',
    submit_error: 'Fehler beim Senden der Einträge',
    validation_error: 'Bitte füllen Sie alle Felder korrekt aus, bevor Sie senden',
    filter_placeholder: 'Filtern nach Setor oder Typ',
    apple_variety: 'Apfel-Sorte',
    total_quantity: 'Gesamtmenge',
    sector: 'Setor',
    selectSector: 'Wählen Sie den Sektor',
    dailyChart: 'Tägliche Mengen Diagramm',
  },
  menu: {
    home: 'Startseite',
    welcome: 'Willkommen',
    irrigationDashboard: {
      title: 'Bewässerungsdashboard'
    },
    appleVarieties: {
      title: 'Apfelsorten',
      gala: 'Gala Äpfel',
      fuji: 'Fuji Äpfel'
    },
    colheita: 'Ernte',
    payloads: 'Payloads',
    map: 'Karte',
    farmonaut: {
      title: 'Farmonaut',
      plantations: 'Pflanzungen',
      fields: 'Felder',
      upload: 'Feld-Upload',
      uploadFile: 'Datei-Upload',
      autoFix: 'Auto-Fix Upload',
      validate: 'GeoJSON validieren',
      transform: 'Transformieren',
      comparison: 'Vergleich',
      assignment: 'Zuordnung',
      createFarmonautFields: 'Farmonaut-Felder anlegen',
      health: 'Statusprüfung'
    },
    excelEntryManager: 'Excel-Einträge',
    login: 'Anmelden',
    about: 'Über uns',
    playground: {
      title: 'Playground',
      table: 'Tabelle',
      datatable: 'Datatable',
      upload: 'Upload',
      fibuInputChange: 'Fibu Input Change',
      segmented: 'Segmentiert',
      timeline: 'Timeline',
      setor: 'Setor',
      sampleUsage: 'Sample Usage',
      createPlantation: 'Plantation anlegen'
    },
    tests: {
      title: 'Tests',
      i18n: 'I18n-Test'
    },
    test: {
      title: 'Test',
      formily: 'Formily Test'
    }
  },
  farmonaut: {
    geoJsonEditor: {
      label: 'GeoJSON-Geometrie',
      hint: 'Polygon-Format: [[[lon, lat], [lon, lat], ...]]',
      valid: 'Gültiges GeoJSON'
    },
    cropCode: {
      label: 'Kulturcode',
      selectPlaceholder: '-- Kulturcode auswählen --',
      manualLabel: 'Oder manuell eingeben',
      manualPlaceholder: 'z.B. 35, 165',
      notInList: 'Code nicht in der erlaubten Liste (wird beim Absenden validiert)'
    },
    response: {
      copy: 'Kopieren',
      error: 'Fehler',
      failed: 'Fehlgeschlagen',
      invalid: 'Ungültig',
      success: 'Erfolg',
      validResult: 'Gültig',
      response: 'Antwort'
    },
    fieldMap: {
      title: 'Feldkarte (OpenLayers)'
    },
    plantations: {
      title: 'Pflanzungsdaten laden',
      loadActive: 'Aktive Pflanzungen laden',
      loading: 'Laden...',
      selectPlantation: 'Pflanzung auswählen',
      selectPlaceholder: '-- Pflanzung auswählen --',
      details: 'Pflanzungsdetails',
      plantationId: 'Pflanzungs-ID',
      area: 'Fläche',
      anoPlantado: 'Pflanzjahr',
      anoFinal: 'Endjahr',
      active: 'Aktiv',
      farmonautId: 'Farmonaut-ID',
      registered: 'Registriert',
      notRegistered: 'Nicht registriert',
      setorDetails: 'Sektor-Details',
      setorId: 'Sektor-ID',
      setorName: 'Sektor-Name',
      name: 'Name',
      setorArea: 'Sektorfläche',
      center: 'Zentrum',
      hasGeoJson: 'Hat GeoJSON',
      loadingFarmonaut: 'Lade Farmonaut-Felddaten...',
      farmonautData: 'Farmonaut-Felddaten',
      cropCode: 'Kulturcode',
      copyCropCode: 'Kopieren',
      fieldId: 'Feld-ID',
      fieldName: 'Feldname',
      fieldArea: 'Feldfläche',
      paymentType: 'Zahlungsart',
      sowingDate: 'Aussaatdatum',
      expired: 'Abgelaufen',
      paused: 'Pausiert',
      fullJson: 'Vollständige JSON-Antwort',
      showJson: 'Vollständiges JSON anzeigen',
      hideJson: 'JSON ausblenden',
      errorFarmonaut: 'Fehler beim Laden der Farmonaut-Daten',
      sendToFarmonaut: 'An Farmonaut senden (Auto-Fix)',
      useInForms: 'In Formularen verwenden',
      infoMessage: 'Klicken Sie auf "Aktive Pflanzungen laden", um Pflanzungen vom Backend abzurufen.',
      noGeoJson: 'Die ausgewählte Pflanzung hat keine GeoJSON-Daten in ihrem Sektor'
    },
    fields: {
      title: 'Farmonaut-Feld nach ID laden',
      description: 'Wählen Sie eine Farmonaut-Feld-ID aus, um Felddaten zu laden und anzuzeigen.',
      fieldIdLabel: 'Farmonaut-Feld-ID',
      selectField: 'Farmonaut Feld-ID',
      selectPlaceholder: '-- Feld auswählen --',
      loadingFieldIds: 'Lade Feld-IDs...',
      errorFieldIds: 'Fehler beim Laden der Feld-IDs',
      loadField: 'Feld laden',
      reset: 'Zurücksetzen',
      cropCodeSection: 'Kulturcode',
      copyCropCode: 'Kulturcode kopieren',
      fieldDetails: 'Felddetails',
      fieldId: 'Feld-ID',
      fieldName: 'Feldname',
      fieldArea: 'Feldfläche',
      centerCoordinates: 'Zentrumskoordinaten',
      paymentType: 'Zahlungsart',
      sowingDate: 'Aussaatdatum',
      fieldStatus: 'Feldstatus',
      expired: 'Abgelaufen',
      expiring: 'Läuft ab',
      paused: 'Pausiert',
      paid: 'Bezahlt',
      healthData: 'Gesundheitsdaten',
      healthIndicatorLabel: 'Indikator',
      healthIndicatorPlaceholder: 'Indikator wählen',
      viewGraph: 'Graph',
      viewTable: 'Tabelle',
      dateColumn: 'Datum',
      valueColumn: 'Wert',
      rawJson: 'Rohes JSON',
      syncToInternal: 'In interne DB synchronisieren',
      syncToInternalSuccess: 'Synchronisation abgeschlossen. Versucht: {attempted}, Übersprungen: {skipped}, Fehler: {errors}',
      syncErrorNoPlantation: 'Keine Pflanzung mit diesem Farmonaut-Feld verknüpft.',
      updateAllIndices: 'Alle Farmonaut-Indizes in DB aktualisieren',
      updateAllIndicesSuccess: 'Import abgeschlossen. Verarbeitet: {processed}, Erfolgreich: {success}, Fehler: {errors}',
      updateAllIndicesError: 'Fehler beim Aktualisieren der Indizes.',
      weatherData: 'Wetterdaten',
      yieldData: 'Ertragsdaten',
      coordinates: 'Koordinaten',
      sensedDays: 'Erfasste Tage'
    },
    upload: {
      title: 'Feld hochladen',
      fieldName: 'Feldname',
      address: 'Adresse',
      farmerId: 'Landwirt-ID',
      submit: 'Feld hochladen',
      uploading: 'Wird hochgeladen...',
      reset: 'Zurücksetzen'
    },
    fileUpload: {
      title: 'GeoJSON-Datei hochladen',
      fieldName: 'Feldname',
      geoJsonFile: 'GeoJSON-Datei',
      selectFile: 'Wählen Sie eine .geojson oder .json Datei',
      submit: 'Datei hochladen',
      uploading: 'Wird hochgeladen...',
      reset: 'Zurücksetzen'
    },
    autoFix: {
      title: 'Upload mit Auto-Fix',
      description: 'Lädt ein Feld hoch und repariert automatisch häufige GeoJSON-Probleme (LineString zu Polygon, Ringschluss usw.)',
      fieldName: 'Feldname',
      address: 'Adresse',
      farmerId: 'Landwirt-ID',
      hint: 'LineString-Geometrien werden automatisch in Polygon konvertiert',
      submit: 'Upload mit Auto-Fix',
      uploading: 'Wird hochgeladen...',
      reset: 'Zurücksetzen',
      repairedGeoJson: 'Repariertes GeoJSON'
    },
    validate: {
      title: 'GeoJSON validieren',
      description: 'GeoJSON validieren ohne an Farmonaut hochzuladen',
      fieldName: 'Feldname',
      cropCode: 'Kulturcode',
      address: 'Adresse',
      farmerId: 'Landwirt-ID',
      submit: 'Validieren',
      validating: 'Wird validiert...',
      reset: 'Zurücksetzen'
    },
    transform: {
      title: 'In Farmonaut-Format umwandeln',
      description: 'Wandelt GeoJSON in das Farmonaut-Format um, ohne es hochzuladen. Zeigt die transformierte Datenstruktur.',
      fieldName: 'Feldname',
      address: 'Adresse',
      farmerId: 'Landwirt-ID',
      submit: 'Transformieren',
      transforming: 'Wird transformiert...',
      reset: 'Zurücksetzen',
      transformedGeoJson: 'Transformiertes GeoJSON (Farmonaut-Format)',
      copyToClipboard: 'In Zwischenablage kopieren',
      copied: 'Kopiert!'
    },
    comparison: {
      title: 'Feld- & Pflanzungsvergleich',
      description: 'Vergleichen Sie Farmonaut-Felddaten mit Pflanzungsdaten auf einer einzigen Karte',
      farmonautFieldId: 'Farmonaut-Feld-ID',
      selectFieldPlaceholder: '-- Feld auswählen (optional) --',
      selectPlantation: 'Pflanzung auswählen',
      selectPlantationPlaceholder: '-- Pflanzung auswählen --',
      loadPlantations: 'Pflanzungen laden',
      loadField: 'Farmonaut-Feld laden',
      loadFarmonautField: 'Farmonaut-Feld laden',
      loadPlantation: 'Pflanzung laden',
      loadComparison: 'Vergleich laden',
      reset: 'Zurücksetzen',
      farmonautField: 'Farmonaut-Feld (Blau)',
      farmonautFieldBlue: 'Farmonaut-Feld (Blau)',
      plantation: 'Pflanzung (Grün)',
      plantationGreen: 'Pflanzung (Grün)',
      plantationId: 'Pflanzungs-ID',
      setorName: 'Sektor-Name',
      fieldId: 'Feld-ID',
      fieldName: 'Feldname',
      area: 'Fläche',
      cropCode: 'Kulturcode',
      farmonautId: 'Farmonaut-ID',
      notRegistered: 'Nicht registriert',
      assignFarmonautId: 'Farmonaut-ID zuordnen',
      assigning: 'Wird zugeordnet...',
      comparisonMap: 'Vergleichskarte',
      legendFarmonaut: 'Farmonaut-Feld',
      legendPlantation: 'Pflanzung',
      loadingData: 'Daten werden geladen...',
      loadingFieldIds: 'Lade Feld-IDs...',
      farmonautFieldError: 'Fehler beim Farmonaut-Feld',
      plantationError: 'Fehler bei der Pflanzung',
      assignmentError: 'Fehler bei der Zuordnung'
    },
    validation: {
      description: 'GeoJSON validieren ohne an Farmonaut hochzuladen',
      fieldName: 'Feldname',
      fieldNamePlaceholder: 'Feldname eingeben',
      cropCode: 'Kulturcode',
      cropCodePlaceholder: 'z.B. 35, 165',
      cropCodeHint: 'Code wird beim Absenden validiert',
      address: 'Adresse',
      addressPlaceholder: 'Optionale Adresse',
      farmerId: 'Landwirt-ID',
      farmerIdPlaceholder: 'Optionale Landwirt-ID',
      validate: 'Validieren',
      reset: 'Zurücksetzen'
    },
    createFarmonaut: {
      title: 'Farmonaut-Felder aus Pflanzungen anlegen',
      description: 'Pflanzungen ohne Farmonaut-ID auswählen und aus ihren GeoJSON-Daten neue Farmonaut-Felder anlegen.',
      loading: 'Laden...',
      refresh: 'Pflanzungen aktualisieren',
      withoutId: '{count} Pflanzung(en) ohne Farmonaut-ID',
      noPlantations: 'Keine Pflanzungen ohne Farmonaut-ID gefunden.',
      allLinked: 'Alle aktiven Pflanzungen sind Farmonaut-Feldern zugeordnet.',
      plantation: 'Pflanzung',
      created: 'Angelegt',
      creating: 'Wird angelegt...',
      error: 'Fehler',
      plantationDetails: 'Pflanzungsdetails',
      geojsonPreview: 'GeoJSON-Vorschau',
      createField: 'Farmonaut-Feld anlegen',
      createButton: 'Farmonaut-Feld anlegen',
      successTitle: 'Farmonaut-Feld erfolgreich angelegt!',
      fieldId: 'Farmonaut-Feld-ID',
      linked: 'Die Pflanzung wurde diesem Farmonaut-Feld zugeordnet.',
      transformDetails: 'Transformationsdetails anzeigen',
      noGeojson: 'Nein – Farmonaut-Feld kann nicht erstellt werden',
      noGeojsonAlert: 'Die gewählte Pflanzung hat keine GeoJSON-Daten im Sektor.',
      noDesignacao: 'Der Sektor der Pflanzung hat keinen Namen (designacao). Farmonaut-Feld kann nicht erstellt werden.',
      confirmTitle: 'Farmonaut-Feld anlegen?',
      confirmMessage: 'Farmonaut-Feld für Pflanzung {id} anlegen? Sektor: {name}, Kulturcode: {cropCode}. Es wird ein neues Farmonaut-Feld angelegt und dieser Pflanzung zugeordnet.'
    },
    assignment: {
      title: 'Feld- & Pflanzungszuordnung',
      description: 'Ordnen Sie Farmonaut-Feld-IDs Pflanzungen zu. Jedes Feld hat eine eigene Karte zum visuellen Vergleich.',
      loadingSummaries: 'Lade Feldzusammenfassungen und Pflanzungen...',
      noFields: 'Keine Farmonaut-Felder gefunden.',
      fieldId: 'Feld-ID',
      assignedTo: 'Zugeordnet zu Pflanzung {id}',
      notAssigned: 'Nicht zugeordnet',
      selectPlantation: '-- Pflanzung auswählen --',
      assign: 'Zuordnen',
      assigning: 'Wird zugeordnet...',
      successAssigned: 'Erfolgreich zugeordnet!',
      loadingMap: 'Lade Kartendaten...'
    },
    health: {
      title: 'Statusprüfung',
      checkHealth: 'Status prüfen',
      checking: 'Wird geprüft...',
      infoMessage: 'Klicken Sie auf "Status prüfen", um zu überprüfen, ob der Farmonaut-Service läuft.'
    },
    common: {
      loading: 'Laden...',
      error: 'Fehler',
      noData: 'K.A.',
      yes: 'Ja',
      setor: 'Sektor',
      plantation: 'Pflanzung',
      area: 'Fläche',
      planted: 'Gepflanzt'
    }
  },
  createPlantation: {
    title: 'Neue Pflanzung anlegen',
    setor: 'Setor',
    selectSetor: '-- Setor auswählen --',
    subtipo: 'Subtipo',
    selectSubtipo: '-- Subtipo auswählen --',
    filas: 'Filas',
    arvores: 'Árvores',
    optionalFields: 'Optionale Felder',
    area: 'Fläche (ha)',
    plantasPorHa: 'Pflanzen pro Ha',
    anoPlantado: 'Ano Plantado',
    anoFinal: 'Ano Final',
    origem: 'Origem',
    custoPlantacao: 'Custo Plantação',
    formaTreinamento: 'Forma Treinamento',
    cobertura: 'Cobertura',
    submit: 'Pflanzung anlegen',
    creating: 'Wird angelegt...',
    reset: 'Zurücksetzen',
    activeWarning: 'Dieser Setor hat bereits eine aktive Pflanzung. Sie können keine neue anlegen.',
    success: 'Pflanzung erfolgreich angelegt! ID: {id}',
    errorActive: 'Pflanzung kann nicht angelegt werden: Setor hat bereits eine aktive Pflanzung',
    errorGeneric: 'Pflanzung konnte nicht angelegt werden'
  },
  errors: {
    404: {
      title: "Seite nicht gefunden",
      message: "Entschuldigung, die gesuchte Seite existiert nicht.",
    },
    403: {
      title: "Zugriff verweigert",
      message: "Entschuldigung, Sie haben keine Berechtigung, auf diese Seite zuzugreifen.",
    },
    actions: {
      goHome: "Zur Startseite",
      goBack: "Zurück",
      login: "Anmelden",
    },
  },
  map: {
    selectMapData: 'Kartendaten auswählen',
    reloadMapData: 'Kartendaten neu laden',
    setoresInformation: 'Sektorinformationen',
    showAll: 'Alle anzeigen',
    showOnMap: 'Auf der Karte anzeigen',
    id: 'ID',
    area: 'Fläche',
    calculateArea: 'Fläche berechnen',
    addGeoJson: 'GeoJSON hinzufügen',
    viewDetails: 'Details anzeigen',
    loadingSetoresInformation: 'Lade Sektorinformationen...',
    editGeoJson: 'GeoJSON bearbeiten',
    enterGeoJsonForSetor: 'GeoJSON für Sektor eingeben',
    enterValidGeoJson: 'Gültiges GeoJSON eingeben',
    invalidGeoJsonFormat: 'Ungültiges GeoJSON-Format',
    viewGeoJson: 'GeoJSON anzeigen',
    geoJsonForSetor: 'GeoJSON für Sektor',
    mapCoordinates: 'Kartenkoordinaten',
    clickedPosition: 'Geklickte Position',
    longitude: 'Längengrad',
    latitude: 'Breitengrad',
    copyCoordinates: 'Koordinaten kopieren',
    debugInformation: 'Debug-Informationen',
    mapData: 'Kartendaten',
    validFeatures: 'Gültige Merkmale',
    setores: 'Sektoren',
    testCoordinates: 'Testkoordinaten',
    enterGeoJsonCoordinatesArray: 'GeoJSON-Koordinatenarray eingeben',
    testPolygon: 'Polygon testen',
    invalidJsonFormat: 'Ungültiges JSON-Format',
    testFeature: 'Testmerkmal',
    projection: 'Projektion',
    center: 'Zentrum',
    calculateTotalArea: 'Gesamtfläche berechnen',
    totalArea: 'Gesamtfläche der ausgewählten Sektoren'
  },
} 